import { customAlphabet, nanoid } from 'nanoid';

const LOWER_ALNUM = '0123456789abcdefghijklmnopqrstuvwxyz';

/**
 * Board ids appear in share links, so they must be unguessable:
 * 16 characters of [0-9a-z] is ~82 bits of entropy and stays URL-friendly.
 */
export const newBoardId: () => string = customAlphabet(LOWER_ALNUM, 16);

/** Ids for frames, elements, assets and other records (~72 bits). */
export function newId(): string {
  return nanoid(12);
}
